/**
 * States of execution result for status of API connections
 *
 * @readonly
 * @enum {string}
 */
export const ColdChainApiConnectionExecutionResultEnum = Object.freeze({
    ERROR: 'Error',
    PENDING: 'Pending',
    SUCCESS: 'Success'
})
